import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { WrapperCard } from "./styled";
import { TableUsers } from "./TableUser";
import { AdminMenuLayout, ModalUsers } from "../../../shared/components";
import { useUsers } from "../hooks/useUsers";
import { selectModalUser } from "../../../redux";
import { useSelector } from "react-redux";
import { FormProvider } from "react-hook-form";

export const Users = () => {
  const modalUser = useSelector(selectModalUser);
  const {
    isUpdateUser,
    formMethodsCreate,
    formMethodsUpdate,
    changeModalUserState,
  } = useUsers();
  // const [tableProps, setTableProps] = useState<TableProperties>();
  return (
    <AdminMenuLayout pageDescription="Users" title="Users">
      <WrapperCard>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              type="primary"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={changeModalUserState}
            >
              Agregar nuevo usuario
            </Button>
          </Col>
        </Row>
        <TableUsers />
      </WrapperCard>
      {modalUser && isUpdateUser && (
        <FormProvider {...formMethodsUpdate}>
          <ModalUsers />
        </FormProvider>
      )}
      {modalUser && !isUpdateUser && (
        <FormProvider {...formMethodsCreate}>
          <ModalUsers />
        </FormProvider>
      )}
    </AdminMenuLayout>
  );
};
